import * as actionTypes from 'constants/ActionTypes';

export function getStatisticsUsers(from, until) {
    return {
        type: actionTypes.GET_STATISTICS_USERS.REQUEST,
        from,
        until,
    };
}

export function searchStatisticsUsers(searchText) {
    return {
        type: actionTypes.SEARCH_STATISTICS_USERS,
        searchText,
    };
}


// WEBPACK FOOTER //
// ./app/actions/statistics/users.js